import { Component, Input, OnChanges, OnInit } from '@angular/core';
import {
  ControlContainer,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

@Component({
    selector: 'phones',
    templateUrl: './phones.component.html',
    styleUrls: ['./phones.component.scss'],
    standalone: false
})
export class PhonesComponent implements OnInit, OnChanges {
  contactPhones: UntypedFormArray;
  frenchMobilePhoneRegex = /^0(6\d{8}|7\d{8}|69\d{7})$/;

  @Input() derrors: any = undefined;
  countries: any[];

  constructor(private controlContainer: ControlContainer) {}

  ngOnInit() {
    this.contactPhones = this.controlContainer.control as UntypedFormArray;
  }

  showWarningMobilePhone(value) {
    if (!value?.e164Number) return false;

    const mobilePhone = value.e164Number;

    const isValidAndFrenchMobilePhone =
      mobilePhone &&
      mobilePhone.length === 12 &&
      (mobilePhone.startsWith('+336') || mobilePhone.startsWith('+337'));

    if (!isValidAndFrenchMobilePhone) return false;

    const isValid = this.frenchMobilePhoneRegex.test(
      mobilePhone.replace('+33', '0'),
    );

    return !isValid;
  }

  addFields() {
    if (this.contactPhones.valid) {
      this.contactPhones.push(
        new UntypedFormGroup({
          phone: new UntypedFormControl('', [
            Validators.required,

            Validators.minLength(9),
          ]),
        }),
      );

      this.contactPhones.markAsUntouched();
    } else {
      this.contactPhones.markAllAsTouched();
    }
  }

  deleteFields(index) {
    this.contactPhones.removeAt(index);
  }

  ngOnChanges() {
    if (this.contactPhones)
      this.contactPhones.controls.forEach(control => {
        control.setValidators([Validators.required]);
        control.updateValueAndValidity();
      });
  }
}
